import script from "./ModalError.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalError.vue?vue&type=script&setup=true&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=02f57f8f&lang=css"

const __exports__ = script;

export default __exports__